import axios from 'axios'
import endpoints from '@/api/endpoints'
import _ from 'lodash'
import router from '@/router'

export default {
  async updateUser (obj) {
    return axios.patch(endpoints.users + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async createUser (obj) {
    // This endpoint simply creates the new user (the API also creates the Profile)
    return await axios.post(endpoints.users, obj).then((response) => {
      return response.data
    })
  },
  async emailNewUser (uid) {
    // This actually sends the new user an email with login details
    // Now, the "NewUserPassword" backend function requires these fields to be posted:
    // - `uid` id of the user object
    // - `cpmURL` URL of the login page
    let loginURL = router.resolve({ name: 'Login' })
    let login = window.location.host + '/' + loginURL.href

    let accountDetails = {
      uid: uid,
      cpmURL: login
    }
    axios.post(endpoints.newUserPassword, accountDetails)
  },
  async isUsernameAvailable (usrnm) {
    let tmp = { username: usrnm }
    return axios.post(endpoints.isUsernameAvailable, tmp).then((response) => {
      return response.data
    })
  },
  async getProfiles () {
    return axios.get(endpoints.profiles).then((response) => {
      return _.orderBy(response.data, 'name_display')
    })
  },
  async getProfile (profileID) {
    return axios.get(endpoints.profiles + profileID + '/').then((response) => {
      return response.data
    })
  },
  async getUserProfile (userID) {
    // Mainly used when creating a new user, and we need the new Profile
    return axios.get(endpoints.getUserProfile + userID + '/').then((response) => {
      return response.data
    })
  },
  async updateProfile (obj) {
    return axios.patch(endpoints.profiles + obj.id + '/', obj).then((response) => {
      return response.data
    })
  },
  async getAppAccess (userID) {
    // We use the User object to ensure deep level control on the API
    return axios.get(endpoints.appAccess + '?user=' + userID).then((response) => {
      return response.data
    })
  },
  async addAppAccess (obj) {
    // obj here is the object of:
    //    { user: ID, app: ID }
    return axios.post(endpoints.appAccess, obj).then((response) => {
      return response.data
    })
  },
  async removeAppAccess (accessID) {
    // accessID here is the object of:
    //    { user: ID, app: ID }
    // it is not the actual APP object
    return axios.delete(endpoints.appAccess + accessID + '/').then((response) => {
      return response.data
    })
  }
}
